import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const CardContainer = styled.div`
  width: 100%;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.r600};
  color: ${({ theme }) => theme.colors.white};
  padding: 10px 4px 4px 4px;
`;

const CardHeader = styled.h1`
  font-size: 18px;
  font-weight: 900;
  line-height: 18px;
  margin: 0;
`;

const CardText = styled.div`
  margin: 0;
  padding: 5px;
`;

const NotificationCard = ({ titleText, bodyText }) => {
  return (
    <CardContainer>
      <CardHeader dangerouslySetInnerHTML={{ __html: titleText }} />
      <CardText dangerouslySetInnerHTML={{ __html: bodyText }} />
    </CardContainer>
  );
};

NotificationCard.propTypes = {
  titleText: PropTypes.string,
  bodyText: PropTypes.string,
};

export default NotificationCard;
